"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRedirectUserToTermsPage = exports.getAllRegions = exports.SubmitAcceptTerms = exports.changeStep = exports.validateStep = exports.ytj = exports.customer = void 0;
const t = require("io-ts");
const fp = require("fp-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/firstLogin/form");
const Actions = require("../../actions/firstLogin/form");
const userValidation_1 = require("../../utils/userValidation");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
const firstLogin_1 = require("../../reducers/firstLogin");
const validation_1 = require("../../utils/validation");
const customerEpics = require("./customer");
exports.customer = customerEpics;
const ytjEpics = require("./ytj");
exports.ytj = ytjEpics;
const validateStep = (page) => (store) => {
    const currentPage = firstLogin_1.pageLens.get(store.firstLogin);
    if (currentPage === 0) {
        const values = firstLogin_1.step1Lens.get(store.firstLogin);
        const user = values.user;
        if (store.auth.current.user
            .map((x) => x.company && x.company.length > 0)
            .getOrElse(false)) {
            // If user has company, ignore company validation
            return (0, userValidation_1.validateUserInformation)(user);
        }
        return (0, validation_1.ap)((0, validation_1.isNotNaN)('company')(store.firstLogin.customerId))((0, userValidation_1.validateUserInformation)(user));
    }
    return fp.validation.success(true);
};
exports.validateStep = validateStep;
function changeStep(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CHANGE_STEP), (0, operators_1.mergeMap)((request) => (0, exports.validateStep)(request.payload.page)(store.value).fold((e) => (0, rxjs_1.of)(Actions.validateStepFailure(e)), (_) => (0, rxjs_1.of)(Actions.validateStepSuccess(request.payload.page)))));
}
exports.changeStep = changeStep;
const resolveFirstTimeLoginRequestBody = (store) => {
    return Object.assign(Object.assign({}, store.firstLogin.step1.user), { avatar: store.firstLogin.avatar, termsVersion: store.firstLogin.termsVersion, hasAcceptedTerms: store.firstLogin.hasAcceptedTerms, hasAcceptedMarketingConsent: store.firstLogin.hasAcceptedMarketingConsent });
};
function SubmitAcceptTerms(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.SUBMIT_FIRST_LOGIN_REQUEST), (0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: resolveFirstTimeLoginRequestBody(store.value),
        url: `${baseUrl}api/auth/first-time`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const v = sok_types_1.User.iUser.decode(response);
        return v.fold((err) => (0, rxjs_1.of)(Actions.submitFirstLoginFailure((0, errorHandling_1.parseValidationError)(err))), () => (0, rxjs_1.of)(Actions.submitFirstLoginSuccess()));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.submitFirstLoginFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.SubmitAcceptTerms = SubmitAcceptTerms;
function getAllRegions(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REGIONS_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/region`,
        allowCache: true
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t.array(sok_types_1.Region.iRegion).decode(response);
        const act = validation.fold((err) => Actions.fetchRegionsFailed((0, errorHandling_1.parseValidationError)(err)), (e) => Actions.fetchRegionsSuccess(e.filter(({ code }) => code !== 'GLOBAL')));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchRegionsFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.getAllRegions = getAllRegions;
function shouldRedirectUserToTermsPage(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.SHOULD_REDIRECT_USER_TO_TERMS_PAGE), (0, operators_1.mergeMap)(() => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/auth/terms`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validate = t
            .interface({
            message: t.boolean
        })
            .decode(response);
        const act = validate.fold((e) => Actions.shouldRedirectUserToTermsPageFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)), (c) => {
            return Actions.shouldRedirectUserToTermsPageSuccess(c.message);
        });
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.shouldRedirectUserToTermsPageFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.shouldRedirectUserToTermsPage = shouldRedirectUserToTermsPage;
//# sourceMappingURL=index.js.map